const StateLoggerPluginId = Symbol('MyStateWatchPlugin');

export function StateLoggerPlugin() {
    return {
        id: StateLoggerPluginId,
        init: (s) => {
            const label = StateLoggerPlugin.label;
            const trace = StateLoggerPlugin.trace;
            return {
                onSet: (data) => {
                    console.log(`${label}::SET_STATE`, data.state);
                    trace && console.trace(`Set hook state for ${label}`);
                },
                onDestroy: (data) => {
                    console.log(`${label}::DESTROYED`, data.state, data.path);
                },
                onBatchStart: (data) => {
                    console.log(
                        `${label}::BATCH_STARTED`,
                        data.state,
                        data.path,
                        data.context
                    );
                },
                onBatchFinish: (data) => {
                    console.log(
                        `${label}::BATCH_FINISHED`,
                        data.state,
                        data.path,
                        data.context
                    );
                },
            };
        },
    };
}

export const createStateLoggerPlugin = (label, trace = false) => {
    StateLoggerPlugin.label = label;
    StateLoggerPlugin.trace = trace;
    return StateLoggerPlugin;
};

export function stateToObject(state) {
    return state.get({ noproxy: true, stealth: true });
}

export function stateToEntries(state) {
    return Object.entries(stateToObject(state));
}
